// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import axios from 'axios'
const baseUrl = "/api";

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

// Update CSRF token header whenever it changes
const updateCsrfToken = () => {
    const csrfToken = getCookie('csrftoken');
    if (csrfToken) {
        axios.defaults.headers.common['X-CSRFToken'] = csrfToken;
    }
};

updateCsrfToken();

axios.defaults.withCredentials = true
let accessToken = null;

//request interceptor to add the auth token header to requests
axios.interceptors.request.use(
  (config) => {
    if (accessToken) {
      config.headers["Authorization"] = "Bearer " + accessToken;
      config.headers["CUUID"] = sessionStorage.getItem("CUUID");

      const csrf = getCookie("csrftoken");
      if (csrf) {
        config.headers["X-CSRFToken"] = csrf;
      }
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

let refreshing = false;

//response interceptor to refresh token on receiving token expired error
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    const originalRequest = error.config;

    
    if (error.response.status === 401 && !originalRequest._retry && (originalRequest.url != "/api/token/refresh/" )) 
    {
      originalRequest._retry = true;

      return axios
        .post(`${baseUrl}/token/refresh/`, {})
        .then((res) => {
          if (res.status === 200) {
            accessToken = res.data.access;
            if (originalRequest.url == "/api/token/verify/"){
              originalRequest.data = {'token':res.data.access}
            }
            return axios(originalRequest);
          }
          else {
            return Promise.reject(error);
          }

        });
    }
    return Promise.resolve(error);
  }
);



const axiosBaseQuery =
  ({ baseUrl } = { baseUrl: '' }) =>
  async ({ url, method, data, params }) => {
    try {
      const result = await axios({ url: baseUrl + url, method, data, params })
      if (axios.isAxiosError(result)){
        return {
          error: {
            status: result.response?.status,
            data: result.response?.data || result.message,
          },
        }
      }
      return {data: result.data}
    } catch (AxiosError) {
      let err = AxiosError
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      }
    }
  }

  // Define a service using a base URL and expected endpoints
export const rtkapi = createApi({
    baseQuery: axiosBaseQuery({
        baseUrl: '/api',
    }),
    endpoints: () => ({})
})